<template>
  <v-row row wrap>
    <v-col>
      <v-select
        v-model="selected"
        :items="typesList"
        item-text="label"
        item-value="value"
        :hide-details="true"
        dense
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";

import {
  GET_PULSE_PARAMS,
  SAVE_PREFERENCES,
  GET_PULSE_REFRESH_MAP,
} from "@/store/actions.type";
import { MODULE_PREFIX_PULSE, MODULE_PREFIX_USER } from "@/store";
import { buildPreferences } from "@/services/grids/stability.service";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "PulseTypeBar",
  data: () => ({
    selected: null,
    applyingPrefs: false,
    typesList: [
      {
        label: "Country",
        value: GRIDS_STABILITY_TYPES.country,
      },
      {
        label: "Region",
        value: GRIDS_STABILITY_TYPES.region,
      },
      {
        label: "US County",
        value: GRIDS_STABILITY_TYPES.county,
      },
      {
        label: "City",
        value: GRIDS_STABILITY_TYPES.city,
      },
    ],
  }),
  mounted() {
    this.getPrefs();
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      pulseParams: MODULE_PREFIX_PULSE + "params",
    }),
  },
  methods: {
    updateType() {
      const PREF_PARAMS = buildPreferences({
        preferences: this.preferences,
        type: this.selected || null,
      });

      this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, PREF_PARAMS);

      let params = this.pulseParams;
      params.type = this.selected;
      this.$store.dispatch(MODULE_PREFIX_PULSE + GET_PULSE_PARAMS, params);
      this.$store.dispatch(MODULE_PREFIX_PULSE + GET_PULSE_REFRESH_MAP, true);
      if (params.type && !this.applyingPrefs) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.pulse,
          EVENT_ACTIONS.addDataToMap,
          "pulse_" + params.type
        );
      }
    },
    getPrefs() {
      if (lodashGet(this.preferences, "grids.stability.type")) {
        this.applyingPrefs = true;
        this.selected = this.preferences.grids.stability.type;
      }
    },
  },
  watch: {
    selected() {
      this.updateType();
      if (this.applyingPrefs) {
        this.applyingPrefs = false;
      }
    },
    pulseParams: {
      handler() {
        if (this.pulseParams) {
          this.selected = this.pulseParams.type;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
